import React from "react";
import SocialLink from "../SocialLink";

import { Address, Container, Email, WrapperAddress } from "./styles";

const ContactInfo = () => (
  <Container>
    <WrapperAddress>
      <SocialLink />

      <Address>
        <Email href="mailto:contact@shopping-cart-migration.com">
          contact@shopping-cart-migration.com
        </Email>
      </Address>
    </WrapperAddress>
  </Container>
);

export default ContactInfo;
